export default function selectJiraProjectsById(state, { source }) {
  return state.integrations.thirdPartyData[source].projects.byId
}
